

































// @ts-ignore
import Cookies from 'js-cookie';
import Vue, {VueConstructor} from 'vue'
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import UserMenu from '@/components/SidebarPlugin/UserMenu.vue'
import MobileMenu from '@/components/SidebarPlugin/MobileMenu.vue'
import auth from '@/services/auth'
import ResizePanel from '../../ResizePanel/ResizePanel.vue'
import ResizePanelArrows from '../../ResizePanel/ResizePanelArrows.vue'
import NetworkError from '@/components/NetworkError/NetworkError.vue'
import SidebarAggregator from '../../TabsSidebar/sidebarAggregator.vue'
import breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue'
import {RawUser} from '@/types/entity/RawUser'
import User from '@/models/Users/User'
import LangCheck from '@/components/Langs/LangCheck.vue';

export default (Vue as VueConstructor<Vue & {
  $refs: {
    contentScroll: {
      resetScroll: () => void,
      $refs: {
        content: HTMLElement
      }
    }
  },
  $bus: {
    $on: (name: string, cb: () => void) => void
  }
}>).extend({
  components: {
    breadcrumbs,
    SidebarAggregator,
    ResizePanelArrows,
    TopNavbar,
    ContentFooter,
    UserMenu,
    MobileMenu,
    ResizePanel,
    NetworkError,
    LangCheck
  },
  data () {
    return {
      userLoaded: false,
      focusCheck: false,
    }
  },
  computed: {
    noFooter (): boolean {
      return this.$route.meta && this.$route.meta.noFooter
    },
    dashboardClasses (): string[] {
      let flags = ['sidebarOpened', 'sidebarMinimized', 'bodyMaximized', 'resizePanelsHovered'];
      let classes = []
      for (let flag of flags) {
        if (this.$store.getters[flag]) {
          classes.push(flag)
        }
      }
      return classes
    },
    user (): User | false {
      return this.$store.state.user.user
    }
  },
  methods: {
    async loadUser () {
      await this.$store.dispatch('user/loadUser', true).then(response => {
        if (response.data.lang && response.data.lang !== Cookies.get('lang_checked')) {
          Cookies.set('lang_checked', response.data.lang)
          window.location.reload(false);
        }
      });
    },
    onScroll (event: UIEvent) {
      this.$root.$emit('contentOnScroll', event)
    },
    onResize (element: HTMLElement) {
      this.$root.$emit('contentOnResize', element)
    },
    closeSidebar () {
      this.$store.commit('sidebarOpened', false)
    },
    logout () {
      this.$store.dispatch('user/logout')
      this.$router.push('/login')
    },
    resetScroll () {
      this.$refs.contentScroll.resetScroll()
    },
    focusOnContent () {
      // this.$refs.contentScroll.$refs.content.focus()
    },
    scrollToPosition (top: number) {
      this.$refs.contentScroll.$refs.content.scrollTop = top
    },
    checkFocus () {
      if (this.focusCheck) {
        requestAnimationFrame(() => {
          if (document.activeElement && document.activeElement.tagName === 'BODY') {
            this.focusOnContent()
          }
          this.checkFocus()
        })
      }
    }
  },
  async mounted () {
    await this.loadUser();
    this.focusCheck = true
    this.checkFocus()
    this.$root.$on('resetScroll', this.resetScroll)
    this.$root.$on('focusOnContent', this.focusOnContent)
    this.$root.$on('scrollToPosition', this.scrollToPosition)
    this.focusOnContent()
    this.$bus.$on('userInfoUprate', () => {
      this.loadUser()
    })
  },
  beforeDestroy () {
    this.focusCheck = false
    this.$root.$off('resetScroll', this.resetScroll)
    this.$root.$off('focusOnContent', this.focusOnContent)
    this.$root.$off('scrollToPosition', this.scrollToPosition)
  }
})
